interface ApiConfig {
  API_URL: string;
  API_KEY: string;
}
interface Config {
  api: ApiConfig;
}

const config: Config = {
  api: {
    API_URL: 'https://api-node.themesbrand.website',
    API_KEY: 'JwCtQJysrpFMndQ5sFaEoB3jQba4CxRO7B0dnOCME=',
  },
};

export default config;
